import React from "react";
import { Diamond, HelpCircle, Euro, Mail, Bell, AlertTriangle, Phone } from "lucide-react";

// Fixed icon choices for internal planning-note planner symbols.
export const PLANNING_ICON_OPTIONS = [
  { value: "production",        label: "Produktion / Weiterarbeiten" },
  { value: "follow_up",         label: "Nachfragen" },
  { value: "invoice",           label: "Rechnung stellen" },
  { value: "email",             label: "Mail senden" },
  { value: "payment_reminder",  label: "Zahlungserinnerung" },
  { value: "warning",           label: "Warnung / Abgabetermin" },
  { value: "call",              label: "Anruf" },
];

export const PLANNING_ICON_VALUES = PLANNING_ICON_OPTIONS.map((o) => o.value);

/**
 * Renders the correct compact planner icon for a given `planner_icon` value.
 * Kept small and mono-color; the caller controls color/size via props.
 */
export function PlanningIcon({ icon, size = 12, color = "#0f172a" }) {
  const props = { size, color, strokeWidth: 2.4 };
  switch (icon) {
    case "follow_up":
      return <HelpCircle {...props} />;
    case "invoice":
      return <Euro {...props} />;
    case "email":
      return <Mail {...props} />;
    case "payment_reminder":
      return <Bell {...props} />;
    case "warning":
      return <AlertTriangle {...props} />;
    case "call":
      return <Phone {...props} />;
    case "production":
    default:
      return <Diamond {...props} />;
  }
}
